import React, { Fragment } from "react";
import "./disclaimer.scss";

const Disclaimer = () => {
  return (
    <Fragment>
      <div className="disclaimer">
        <div className="container1500">
          <h2>Disclaimer :</h2>
          <div className="desc">
            <p>
            Claim Solutions Scotland Ltd T/A Housing Disrepair Heroes is a Claims Management Company (CMC). You do not have to use a Claims Management Company or Solicitor to pursue a claim. You can claim for free, without using a claims management company, first to your landlord or to the Housing Ombudsman Service (England)/Public Services Ombudsman (Scotland & Wales).
            </p>
            <p>
            Claim Solutions Scotland Ltd is authorised and regulated by the Financial Conduct Authority in respect of regulated claims management activities, registration number: 837720
            </p>
            <br />
           
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Disclaimer;
